import { useGetSession } from '@/services';
import { useResumeSchedulingPayAfterAuth } from '@/hooks/useResumeSchedulingPayAfterAuth';
import { decodeUrl, isSchedulingPayAfterAuthPending } from '@/utils';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PaymentContainer } from './PaymentContainer';
import { useStep } from '@/hooks';
import { E2E_SCHEDULING } from '@/constants/e2eSchedulingTestIds';
import { Loader2 } from 'lucide-react';

const StepPayment = () => {
	const navigate = useNavigate();
	const [searchParams] = useSearchParams();
	const [sessionId, setSessionId] = useState('');
	const payAfterAuthStarted = useRef(false);

	const { nextStep } = useStep();

	const encodedUrl = searchParams.get('d');
	const pendingPayAfterAuth = isSchedulingPayAfterAuthPending();

	const { data: sessionData } = useGetSession(sessionId || '', {
		enabled: !!sessionId,
	});

	const { resumeSchedulingPayAfterAuth } = useResumeSchedulingPayAfterAuth();

	useEffect(() => {
		if (encodedUrl) {
			const decodedUrl = decodeUrl(encodedUrl);
			if (decodedUrl.session && typeof decodedUrl.session === 'string') {
				setSessionId(decodedUrl.session);
			}
		}
	}, [encodedUrl]);

	useEffect(() => {
		if (!pendingPayAfterAuth || sessionId || payAfterAuthStarted.current) {
			return;
		}
		payAfterAuthStarted.current = true;
		void resumeSchedulingPayAfterAuth(navigate);
	}, [
		navigate,
		pendingPayAfterAuth,
		resumeSchedulingPayAfterAuth,
		sessionId,
	]);

	if (pendingPayAfterAuth && !sessionId) {
		return (
			<section
				className="flex w-full justify-center"
				data-testid={E2E_SCHEDULING.PAYMENT_ROOT}
			>
				<div className="flex flex-col items-center justify-center gap-4 py-16">
					<Loader2 className="size-12 animate-spin text-stone-400" />
					<p className="text-stone-600">Preparando pagamento…</p>
				</div>
			</section>
		);
	}

	return (
		<section className="flex w-full justify-center">
			{sessionData && (
				<div
					className="flex w-full max-w-5xl flex-col items-center justify-center gap-8"
					data-testid={E2E_SCHEDULING.PAYMENT_ROOT}
				>
					<PaymentContainer
						session={sessionData}
						onPaymentClick={nextStep}
						navigate={navigate}
					/>
				</div>
			)}
		</section>
	);
};

export { StepPayment };
